export default __webpack_public_path__ + "static/media/unchecked.cd059141.svg";